<div class="loading-container" *ngIf="loadSpinner">
    <kendo-loader *ngIf="loadSpinner" type="converging-spinner" size="large"></kendo-loader>
</div>
<div *ngIf="form">
    <form class="k-form k-form-md" [formGroup]="form">
        <div class="layout">
            <div class="contact-details k-my-4">
                <div class="k-d-flex k-justify-content-stretch">
                    <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                        <kendo-formfield>
                            <kendo-label text="Case Closing Date *" [for]="closeDate"></kendo-label>
                            <kendo-datepicker formControlName="closeDate" calendarType="classic" rounded="large"
                                [format]="format" [min]="minDate" [max]="maxDate" [value]="defaultDate"
                                #closeDate></kendo-datepicker>
                            <kendo-formerror>Invalid date - date should be between {{ minDate.toLocaleDateString() }}
                                and {{ maxDate.toLocaleDateString() }}</kendo-formerror>
                        </kendo-formfield>
                    </div>
                </div>
            </div>

            <div class="k-mt-2 k-pb-2">
                <div class="k-d-inline-block ip-control k-pr-4">
                    <kendo-formfield>
                        <p>Does this student have an Impartial Hearing in process? *</p>
                        <ul class="k-radio-list ">
                            <li class="k-radio-item k-ml-2">
                                <input type="radio" #Yes value="Yes" kendoRadioButton
                                    formControlName="requiresImpartial" />
                                <kendo-label [for]="Yes" text="Yes"></kendo-label>
                            </li>
                            <li class="k-radio-item k-ml-2">
                                <input type="radio" #No value="No" kendoRadioButton
                                    formControlName="requiresImpartial" />
                                <kendo-label [for]="No" text="No"></kendo-label>
                            </li>
                        </ul>
                        <kendo-formerror>Error: Impartial Hearing is mandatory</kendo-formerror>
                    </kendo-formfield>
                    <p *ngIf="form.value?.requiresImpartial === yes"> <span class="required">The case cannot be closed
                            when there is an Impartial Hearing in process.</span> </p>
                </div>
            </div>

            <div class="contact-details k-my-4">
                <div class="k-d-flex k-justify-content-stretch">
                    <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                        <kendo-label text="Case Closing Reason *" [for]="reason"></kendo-label>
                        <kendo-formfield> <kendo-dropdownlist [data]="referenceData.caseCloseReason" [rounded]="'large'"
                                formControlName="reason" [textField]="'description'" [valueField]="'id'"
                                [valuePrimitive]="true" [size]="'medium'" #reason></kendo-dropdownlist>
                            <kendo-formerror>Error: Selection is mandatory</kendo-formerror>
                        </kendo-formfield>
                    </div>
                </div>
            </div>

            <div class="contact-details k-my-4" *ngIf="showReasonForDelay">
                <div class="k-d-flex k-justify-content-stretch">
                    <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full" formArrayName="reasonForDelays">
                        <ng-container *ngFor="let delay of reasons?.controls; let i = index;" [formGroupName]="i">
                            <kendo-formfield>

                                <kendo-label text="Reason for Delay *" [for]="reasonForDelay"></kendo-label>
                                <kendo-dropdownlist [data]="referenceData?.reasonForDelay" [rounded]="'large'"
                                    [valuePrimitive]="true" [textField]="'description'"
                                    formControlName="reasonForDelayId" [valueField]="'id'" [size]="'medium'"
                                    #reasonForDelay></kendo-dropdownlist>
                                <kendo-formerror>Error: Selection is mandatory</kendo-formerror>
                            </kendo-formfield>
                            <kendo-formfield class="k-my-2 k-w-full">
                                <kendo-floatinglabel text="Description *" class="k-w-full">
                                    <kendo-textbox [size]="'medium'" rounded="large" [fillMode]="'outline'"
                                        formControlName="description">
                                    </kendo-textbox>
                                </kendo-floatinglabel>
                                <kendo-formerror>Error: Please enter description</kendo-formerror>
                            </kendo-formfield>
                        </ng-container>
                        <button kendoButton [svgIcon]="svgPlus" size="large" rounded="large" fillMode="outline"
                            themeColor="info" (click)="addReasonForDelay()">
                            Add Reason For Delay
                        </button>
                    </div>
                </div>
            </div>

            <div class="contact-details k-my-4" *ngIf="showDischargeDetails">
                <div class="k-d-flex k-justify-content-stretch">
                    <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                        <kendo-formfield>
                            <kendo-label text="Please select one of the following Discharge Reasons *"
                                [for]="dischargeReason"></kendo-label>
                            <kendo-dropdownlist [data]="referenceData.dischargeReason" [rounded]="'large'"
                                formControlName="dischargeReason" [textField]="'description'" [valueField]="'id'"
                                #dischargeReason [size]="'medium'"></kendo-dropdownlist>
                            <kendo-formerror>Error: Selection is mandatory</kendo-formerror>
                        </kendo-formfield>
                    </div>
                </div>
            </div>

            <div class="contact-details k-my-4" *ngIf="showDischargeDetails">
                <div class="k-d-flex k-justify-content-stretch">
                    <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                        <kendo-formfield>
                            <kendo-label text="Discharge Date" [for]="dischargeDate"></kendo-label>
                            <kendo-datepicker #dischargeDate calendarType="classic" formControlName="dischargeDate"
                                rounded="large" placeholder="MM/DD/YYYY" [format]="format">
                            </kendo-datepicker>
                            <kendo-formerror>Error: Selection is mandatory</kendo-formerror>
                        </kendo-formfield>
                    </div>
                </div>
            </div>

            <div class="contact-details k-my-4" *ngIf="showFinalNoticeEvaluationProcess">
                <div class="k-d-flex k-justify-content-stretch">
                    <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                        <kendo-formfield>
                            <div class="k-form-field-checkbox-wrap">

                                <input type="checkbox" size="medium" rounded="large" formControlName="withdrawal"
                                    kendoCheckBox class="!k-mr-2" #Withdrawal />
                                <kendo-label [for]="Withdrawal"
                                    text="I have sent the 'Final Notice of Withdrawal from the Evaluation Process: Initial Referral' to the parent." />

                            </div>
                            <kendo-formerror>Error: Selection is mandatory</kendo-formerror>
                        </kendo-formfield>
                    </div>
                </div>
            </div>

            <div class="contact-details k-my-4" *ngIf="showPhoneOutreach">
                <div class="k-d-flex k-justify-content-stretch">
                    <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                        <kendo-formfield>
                            <div class="k-form-field-checkbox-wrap">
                                <input type="checkbox" size="medium" rounded="large" formControlName="phone"
                                    class="!k-mr-2" kendoCheckBox #phone />
                                <kendo-label [for]="phone"
                                    text="I have logged in the student’s event log two phone outreach attempts, one outreach via mail, and one letter sent home with the student." />
                            </div>
                            <kendo-formerror>Error: Selection is mandatory</kendo-formerror>
                        </kendo-formfield>
                    </div>
                </div>
            </div>

            <div class="contact-details k-my-4" *ngIf="showPlaceMent">
                <div class="k-d-flex k-justify-content-stretch">
                    <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                        <kendo-formfield>
                            <div class="k-form-field-checkbox-wrap">
                                <input type="checkbox" size="medium" rounded="large" class="!k-mr-2"
                                    formControlName="placement" kendoCheckBox #Placement />
                                <kendo-label [for]="Placement"
                                    text="I have sent the 'Prior Notice for Placement Withdrawal: Initial' to the parent." />
                            </div>
                            <kendo-formerror>Error: Selection is mandatory</kendo-formerror>
                        </kendo-formfield>
                    </div>
                </div>
            </div>

            <div class="contact-details k-my-4" *ngIf="show45">
                <div class="k-d-flex k-justify-content-stretch">
                    <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                        <kendo-formfield>
                            <div class="k-form-field-checkbox-wrap">
                                <input type="checkbox" size="medium" rounded="large" formControlName="outreachDays"
                                    class="!k-mr-2" kendoCheckBox #45 />
                                <kendo-label [for]="45"
                                    text="I have performed the necessary outreach to the parent, and 45 days have elapsed without receiving consent for provision of services." />
                            </div>
                            <kendo-formerror>Error: Selection is mandatory</kendo-formerror>
                        </kendo-formfield>
                    </div>
                </div>
            </div>

            <div class="contact-details k-my-4" *ngIf="showRevocationConsent">
                <div class="k-d-flex k-justify-content-stretch">
                    <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                        <kendo-formfield>
                            <div class="k-form-field-checkbox-wrap">
                                <input type="checkbox" size="medium" rounded="large" formControlName="revocationConsent"
                                    class="!k-mr-2" kendoCheckBox #consent />
                                <kendo-label [for]="consent"
                                    text="I have received the parent’s revocation of consent." />
                            </div>
                            <kendo-formerror>Error: Selection is mandatory</kendo-formerror>
                        </kendo-formfield>
                    </div>
                </div>
            </div>

            <div class="contact-details k-my-4" *ngIf="showElapsed">
                <div class="k-d-flex k-justify-content-stretch">
                    <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                        <kendo-formfield>
                            <div class="k-form-field-checkbox-wrap">
                                <input type="checkbox" size="medium" rounded="large" formControlName="elapsed"
                                    kendoCheckBox class="!k-mr-2" #elapsed />
                                <kendo-label [for]="elapsed"
                                    text="I have sent the 'Parent Revocation - Final Notice of Termination' and 10 calendar days have elapsed." />
                            </div>
                            <kendo-formerror>Error: Selection is mandatory</kendo-formerror>
                        </kendo-formfield>
                    </div>
                </div>
            </div>

            <div class="contact-details k-my-4" *ngIf="showIneligibilityLetter">
                <div class="k-d-flex k-justify-content-stretch">
                    <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                        <kendo-formfield>
                            <div class="k-form-field-checkbox-wrap">
                                <input type="checkbox" size="medium" rounded="large"
                                    formControlName="ineligibilityLetter" class="!k-mr-2" kendoCheckBox #Letter />
                                <kendo-label [for]="Letter" text="I have completed the ‘Ineligibility Letter’" />
                            </div>
                            <kendo-formerror>Error: Selection is mandatory</kendo-formerror>
                        </kendo-formfield>
                    </div>
                </div>
            </div>

            <div class="contact-details k-my-4" *ngIf="showPwnRecommendation">
                <div class="k-d-flex k-justify-content-stretch">
                    <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                        <kendo-formfield>
                            <div class="k-form-field-checkbox-wrap">
                                <input type="checkbox" size="medium" rounded="large" formControlName="pwnRecommendation"
                                    class="!k-mr-2" kendoCheckBox #Ineligible />
                                <kendo-label [for]="Ineligible"
                                    text="I have sent the ‘PWN Recommendation - Ineligible’ to the parent/guardian" />
                            </div>
                            <kendo-formerror>Error: Selection is mandatory</kendo-formerror>
                        </kendo-formfield>
                    </div>
                </div>
            </div>

            <div class="contact-details k-my-4" *ngIf="showDeclassificationDocument">
                <div class="k-d-flex k-justify-content-stretch">
                    <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                        <kendo-formfield>
                            <div class="k-form-field-checkbox-wrap">
                                <input type="checkbox" size="medium" rounded="large"
                                    formControlName="declassificationDocument" class="!k-mr-2" kendoCheckBox
                                    #Declassification />
                                <kendo-label [for]="Declassification"
                                    text="I have completed the 'Declassification Document'." />
                            </div>
                            <kendo-formerror>Error: Selection is mandatory</kendo-formerror>
                        </kendo-formfield>
                    </div>
                </div>
            </div>

            <div class="contact-details k-my-4" *ngIf="showDeclassificationParent">
                <div class="k-d-flex k-justify-content-stretch">
                    <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                        <kendo-formfield>
                            <div class="k-form-field-checkbox-wrap">
                                <input type="checkbox" size="medium" rounded="large"
                                    formControlName="declassificationParent" class="!k-mr-2" kendoCheckBox #Projected />
                                <kendo-label [for]="Projected"
                                    text="I have sent the ‘PWN Recommendation - Declassification’ to the parent/guardian." />
                            </div>
                            <kendo-formerror>Error: Selection is mandatory</kendo-formerror>
                        </kendo-formfield>
                    </div>
                </div>
            </div>

            <div class="contact-details k-my-4" *ngIf="showProjectedDate">
                <div class="k-d-flex k-justify-content-stretch">
                    <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                        <kendo-formfield>
                            <div class="k-form-field-checkbox-wrap">
                                <input type="checkbox" size="medium" rounded="large" formControlName="projectedDate"
                                    class="!k-mr-2" kendoCheckBox #Projected />
                                <kendo-label [for]="Projected"
                                    text="I have verified that today's date is on or after the ‘Projected Date for Declassification'" />
                            </div>
                            <kendo-formerror>Error: Selection is mandatory</kendo-formerror>
                        </kendo-formfield>
                    </div>
                </div>
            </div>

            <div class="contact-details k-my-4" *ngIf="showParentAndPrincipal">
                <div class="k-d-flex k-justify-content-stretch">
                    <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                        <kendo-formfield>
                            <div class="k-form-field-checkbox-wrap">
                                <input type="checkbox" size="medium" rounded="large" formControlName="referral"
                                    kendoCheckBox class="!k-mr-2" #referral />
                                <kendo-label [for]="referral"
                                    text="I have a signed 'Parent and Principal Written Agreement to Withdraw an Initial Referral' document." />
                            </div>
                            <kendo-formerror>Error: Selection is mandatory</kendo-formerror>
                        </kendo-formfield>
                    </div>
                </div>
            </div>

            <div class="page-footer k-mt-2 k-text-right">
                <div class="action-btns">
                    <div class="action-btns__right">
                        <button kendoButton size="large" rounded="large" fillMode="outline" themeColor="error"
                            (click)="closeDailog()">
                            Cancel
                        </button>
                        &nbsp;
                        <button kendoButton size="large" (click)="submit()"
                            [disabled]="!form.valid || form.value?.requiresImpartial === yes" rounded="large"
                            fillMode="solid" themeColor="primary">
                            Close Case
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>